import styled from "styled-components";
import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";

export const Container = styled.span`
    display: flex;
    flex-direction: column;
    transition: all 0.2s ease;
    border: 3px solid #fff;
    border-radius: 14px;
    cursor: pointer;
    height: fit-content;
    &:hover {
        border: 3px solid ${colors.INTERFACE_COLORS_LAVABEE_YELLOW};
        border-radius: 14px;
        .burnButton{
        /* display: flex; */
        }
    }
    @media (min-width: ${MOBILE}px) {
        width: 23%;
    }
    position: relative;
    .lableText {
        padding-left: 12px;
    }
    .burnButton{
        position: absolute;
        top: 25px;
        right: 25px;
        display: none;
        color: #fff;
    }
`

export const NFTImg = styled.img`
    width: 100%;
    border-radius: 12px;
    @media (max-width: ${MOBILE}px) {
        max-width: 300px;
    }
`

export const RowSpan = styled.span`
    display: flex;
    align-items: center;
`